export const aside = {
    back: {
        title: "Retournez à vos plannings",
        label: "Retour aux plannings"
    },
    delete: {
        confirm: "Voulez-vous vraiment supprimer ce planning ?",
        label: "Supprimer ce planning"
    }
}